export default function MediaCentre() {
  return (
    <div className="privacy-maincard">
      <div style={{ padding: "20px" }}>
        <div className="privacy-maintitle">
          <h1>Media Centre</h1>
          <p>
            Welcome to the LEGITIMATELY Media Centre. Stay informed about the
            latest news and updates.
          </p>
          <div className="privacy_cards">
            <div className="privacy_title">
              <h2>News and Updates</h2>
              <p>
                Discover the latest announcements, partnerships, and innovations
                from LEGITIMATELY.
              </p>
            </div>
            <div className="privacy_title">
              <h2>Media Resources</h2>
              <p>
                Download press kits, official logos, and other resources for
                media use.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
